import React, { Component } from "react";
import { Menu } from "antd";

const SubMenu = Menu.SubMenu;

class SideNav extends Component {
    state = {
        current: '',
    }

    handleClick = e => {
        this.setState({
            current: e.key,
        });
    }

    setOpenKeys = () => {
        const sub1 = [
            '/summary/view/cumInfRan',
            '/summary/view/monInfRam',
            '/summary/view/cumFilRan',
            '/summary/view/monFilRan',
            '/summary/visit/cumVisit',
            '/summary/visit/monVisit',
            "/summary/site/siteInformed",
            "/summary/site/siteFilter",
            "/summary/site/siteRandom",
            "/summary/groupingRate",
            "/summary/groupingRateCompare",
            "/summary/siteGroupingRate"
        ];
        const sub2 = [
            "/summary/fte/cumFTE",
            "/summary/fte/monFTE",
            "/summary/siteFTE"
        ];
        const sub3 = [
            "/summary/preFilter/filterSource",
            "/summary/preFilter/filterReason",
            "/summary/filter",
            "/summary/violation"
        ];
        const sub4 = [
            "/summary/siteStart/Project_Approval",
            "/summary/siteStart/EC_Submit",
            "/summary/siteStart/EC_MEETING",
            "/summary/siteStart/EC_Approvals",
            "/summary/siteStart/Letter_Of_Commitment_Collection",
            "/summary/siteStart/Final_Contract",
            "/summary/siteStart/Contract_Signing",
            "/summary/siteStart/Start_Work_All_Ready",
            "/summary/siteStart/Startup_Meeting_Completed",
        ];
        const curHash = location.hash.substr(1);
        let { curOpenKeys = ["sub1"] } = this.state;
        if (sub1.includes(curHash)) {
            curOpenKeys = ["sub1"];
        } else if (sub2.includes(curHash)) {
            curOpenKeys = ["sub2"];
        } else if (sub3.includes(curHash)) {
            curOpenKeys = ["sub3"];
        } else if (sub4.includes(curHash)) {
            curOpenKeys = ["sub4"];
        }
        this.setState({curOpenKeys});
    }

    componentDidMount() {
        this.setState({
            current: location.hash.substr(1)
        }, () => {
            this.setOpenKeys();
        });
    }

    onOpenChange = (curOpenKeys) =>{
        this.setState({ curOpenKeys })
    }

    render() {
        const { invState, blindType } = sessionStorage;
        const isTotal = invState == 1;
        const isUnBlind = blindType === 'NOTBLIND';       // 非盲项目
        return (
            <aside className="sidebar">
                <Menu
                    onClick={this.handleClick}
                    selectedKeys={[this.state.current]}
                    mode="inline"
                    onOpenChange={this.onOpenChange}
                    openKeys={this.state.curOpenKeys}
                >
                    {
                        isTotal && !isUnBlind &&
                        <SubMenu key="sub4" title={<span><i className="icon iconfont">&#xe60d;</i><span>中心启动情况</span></span>}>
                            <Menu.Item key="/summary/siteStart/Project_Approval"><a href="#/summary/siteStart/Project_Approval">立项</a></Menu.Item>
                            <Menu.Item key="/summary/siteStart/EC_Submit"><a href="#/summary/siteStart/EC_Submit">EC递交</a></Menu.Item>
                            <Menu.Item key="/summary/siteStart/EC_MEETING"><a href="#/summary/siteStart/EC_MEETING">EC会议</a></Menu.Item>
                            <Menu.Item key="/summary/siteStart/EC_Approvals"><a href="#/summary/siteStart/EC_Approvals">EC批件</a></Menu.Item>
                            <Menu.Item key="/summary/siteStart/Letter_Of_Commitment_Collection"><a href="#/summary/siteStart/Letter_Of_Commitment_Collection">承诺书收集</a></Menu.Item>
                            <Menu.Item key="/summary/siteStart/Final_Contract"><a href="#/summary/siteStart/Final_Contract">合同定稿</a></Menu.Item>
                            <Menu.Item key="/summary/siteStart/Contract_Signing"><a href="#/summary/siteStart/Contract_Signing">合同签署</a></Menu.Item>
                            <Menu.Item key="/summary/siteStart/Start_Work_All_Ready"><a href="#/summary/siteStart/Start_Work_All_Ready">启动工作全部ready</a></Menu.Item>
                            <Menu.Item key="/summary/siteStart/Startup_Meeting_Completed"><a href="#/summary/siteStart/Startup_Meeting_Completed">启动会完成</a></Menu.Item>
                        </SubMenu>
                    }
                    {
                        !isUnBlind ?
                            <SubMenu key="sub1" title={<span><i className="icon iconfont">&#xe60d;</i><span>入组情况</span></span>}>
                                <Menu.Item key="/summary/view/cumInfRan"><a href="#/summary/view/cumInfRan">累计知情随机(入组)</a></Menu.Item>
                                <Menu.Item key="/summary/view/monInfRam"><a href="#/summary/view/monInfRam">每月知情随机(入组)</a></Menu.Item>
                                <Menu.Item key="/summary/view/cumFilRan"><a href="#/summary/view/cumFilRan">累计筛选随机(入组)</a></Menu.Item>
                                <Menu.Item key="/summary/view/monFilRan"><a href="#/summary/view/monFilRan">每月筛选随机(入组)</a></Menu.Item>
                                <Menu.Item key="/summary/visit/cumVisit"><a href="#/summary/visit/cumVisit">累计完成访视</a></Menu.Item>
                                <Menu.Item key="/summary/visit/monVisit"><a href="#/summary/visit/monVisit">每月完成访视</a></Menu.Item>
                                {
                                    isTotal && <Menu.Item key="/summary/groupingRate"><a href="#/summary/groupingRate">入组速率趋势</a></Menu.Item>
                                }
                                {
                                    isTotal && <Menu.Item key="/summary/site/siteInformed"><a href="#/summary/site/siteInformed">各中心知情情况</a></Menu.Item>
                                }
                                {
                                    isTotal && <Menu.Item key="/summary/site/siteFilter"><a href="#/summary/site/siteFilter">各中心筛选情况</a></Menu.Item>
                                }
                                {
                                    isTotal && <Menu.Item key="/summary/site/siteRandom"><a href="#/summary/site/siteRandom">各中心随机(入组)情况</a></Menu.Item>
                                }
                                {
                                    isTotal && <Menu.Item key="/summary/groupingRateCompare"><a href="#/summary/groupingRateCompare">各中心入组速率对比</a></Menu.Item>
                                }
                                {
                                    isTotal && <Menu.Item key="/summary/siteGroupingRate"><a href="#/summary/siteGroupingRate">各中心入组速率趋势</a></Menu.Item>
                                }
                                {
                                    isTotal && <Menu.Item key="/summary/standardVisitHourCompare"><a href="#/summary/standardVisitHourCompare">各中心标访工时数对比</a></Menu.Item>
                                }
                            </SubMenu>
                        :
                            <SubMenu key="sub1" title={<span><i className="icon iconfont">&#xe60d;</i><span>入组情况</span></span>}>
                                <Menu.Item key="/summary/visit/cumVisit"><a href="#/summary/visit/cumVisit">累计完成访视</a></Menu.Item>
                                <Menu.Item key="/summary/visit/monVisit"><a href="#/summary/visit/monVisit">每月完成访视</a></Menu.Item>
                            </SubMenu>
                    }
                    <SubMenu key="sub2" title={<span><i className="icon iconfont">&#xe60d;</i><span>FTE情况</span></span>}>
                        <Menu.Item key="/summary/fte/cumFTE"><a href="#/summary/fte/cumFTE">累计FTE情况</a></Menu.Item>
                        <Menu.Item key="/summary/fte/monFTE"><a href="#/summary/fte/monFTE">每月FTE情况</a></Menu.Item>
                        {
                            isTotal && <Menu.Item key="/summary/siteFTE"><a href="#/summary/siteFTE">各中心FTE情况</a></Menu.Item>
                        }
                    </SubMenu>
                    {
                        !isUnBlind ?
                            <SubMenu  key="sub3" title={<span><i className="icon iconfont">&#xe60d;</i><span>数据分析</span></span>}>
                                <Menu.Item key="/summary/preFilter/filterSource"><a href="#/summary/preFilter/filterSource">预筛来源统计</a></Menu.Item>
                                <Menu.Item key="/summary/preFilter/filterReason"><a href="#/summary/preFilter/filterReason">预筛失败原因统计</a></Menu.Item>
                                <Menu.Item key="/summary/filter"><a href="#/summary/filter">筛选失败原因统计</a></Menu.Item>
                                <Menu.Item key="/summary/violation"><a href="#/summary/violation">方案违背分类统计</a></Menu.Item>
                            </SubMenu>
                        :
                            <SubMenu  key="sub3" title={<span><i className="icon iconfont">&#xe60d;</i><span>数据分析</span></span>}>
                                <Menu.Item key="/summary/violation"><a href="#/summary/violation">方案违背分类统计</a></Menu.Item>
                            </SubMenu>
                    }
                </Menu>
            </aside>
        );
    }
}

export default SideNav;



// WEBPACK FOOTER //
// ./src/components/summary/SideNav.js